import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ErrorService } from '@services/error/error.service';
import { OrderType } from '../../types/order.type';
import { Observable, throwError } from 'rxjs';
import { IResponse } from '@interfaces/response';
import { IAuditLog, IAuditUser } from '@interfaces/audit';
import {catchError, share } from 'rxjs/operators';
import { createHttpParams } from '@shared/functions';

interface IPayloadAuditData {
    section: string;
    action: string;
    status: string;
    start: string;
    end: string;
    search: string;
    skip: number;
    limit: number;
    order: OrderType;
    sort: string;
    users: number[];
}

@Injectable({
    providedIn: 'root'
})

export class AuditService {
    constructor(private http: HttpClient,
                private errorService: ErrorService) {
    }

    public getAuditData(payload: Partial<IPayloadAuditData>): Observable<IResponse<IAuditLog>> {
        const params = createHttpParams(
            {
                userIds: payload.users || [],
                section: payload.section || '',
                action: payload.action || '',
                start: payload.start || '',
                end: payload.end || '',
                search: payload.search || '',
                skip: payload.skip || 0,
                limit: payload.limit || 10,
                order: payload.order || 'DESC',
                sort: payload.sort || 'timestamp'
            }
        );


        return this.http.get<IResponse<IAuditLog>>('audit-logs', {params}).pipe(
            share(),
            catchError(err => {
                this.errorService.showError(err);
                return throwError(err);
            })
        );
    }

    public getSectionsWithAction(): Observable<{ [key: string]: string[] }> {
        return this.http.get<{ [key: string]: string[] }>('audit-logs/sections-with-actions').pipe(
            share(),
            catchError(err => {
                this.errorService.showError(err);
                return throwError(err);
            })
        );
    }

    public getUsers(): Observable<IAuditUser[]> {
        return this.http.get<IAuditUser[]>('audit-logs/users').pipe(
            share(),
            catchError(err => {
                this.errorService.showError(err);
                return throwError(err);
            })
        );
    }
}
